import { Skeleton } from '@/components/ui/skeleton';

interface TabsSkeletonProps {
    readonly tabCount?: number;
}

const TAB_WIDTHS = [100, 120, 90, 110] as const;

/**
 * Loading placeholder for a `line`-variant tab strip.
 *
 * The container reproduces `TabsList`'s underline and the triggers' `h-9`
 * box, so the strip does not change height when the real tabs mount.
 */
export function TabsSkeleton({ tabCount = 2 }: TabsSkeletonProps) {
    return (
        <div className="flex w-full items-center gap-0 border-b border-border-default">
            {Array.from({ length: tabCount }).map((_, i) => (
                <div key={i} className="flex h-9 items-center px-4">
                    <Skeleton
                        className="h-2.5 rounded-sm"
                        style={{ width: TAB_WIDTHS[i % TAB_WIDTHS.length] }}
                    />
                </div>
            ))}
        </div>
    );
}
